import { render, staticRenderFns } from "./SchoolEdit.vue?vue&type=template&id=36748cb9&"
import script from "./SchoolEdit.vue?vue&type=script&lang=js&"
export * from "./SchoolEdit.vue?vue&type=script&lang=js&"
import style0 from "./SchoolEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports